<template>
    <div class="explore_home_div">
        <Explore></Explore>
    </div>
</template>

<script type="text/javascript">

import Explore from '@/components/explore_page/explore.vue'

import { mapActions } from 'vuex'

export default {
    components: {
        Explore,
    },
    methods: {

    },

    mounted: function () {

    }
}
</script>
<style type="text/css">
</style>
